import type { SVGProps } from 'react';

export const CheckmarkIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg width="21" height="15" viewBox="0 0 21 15" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M7.05067 11.7L18.3507 0.4C18.6173 0.133333 18.9284 0 19.284 0C19.6396 0 19.9507 0.133333 20.2173 0.4C20.484 0.666667 20.6173 0.983333 20.6173 1.35C20.6173 1.71667 20.484 2.03333 20.2173 2.3L7.984 14.5667C7.71733 14.8333 7.40622 14.9667 7.05067 14.9667C6.69511 14.9667 6.384 14.8333 6.11733 14.5667L0.384 8.83333C0.117333 8.56667 -0.0104444 8.25 0.000666667 7.88333C0.0117778 7.51667 0.150667 7.2 0.417333 6.93333C0.684 6.66667 1.00067 6.53333 1.36733 6.53333C1.734 6.53333 2.05067 6.66667 2.31733 6.93333L7.05067 11.7Z"
        fill="#23C250"
      />
    </svg>
  );
};
